
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bw5U3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $da569087c706f071$export$2e2bcd8739ae039);

var $hShDV = parcelRequire("hShDV");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$da569087c706f071$export$2e2bcd8739ae039 = (0, $hShDV.default);

});
parcelRegister("hShDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8838271b7088541$export$2e2bcd8739ae039);

var $34Vv8 = parcelRequire("34Vv8");

var $gWx6P = parcelRequire("gWx6P");
var $e8838271b7088541$export$2e2bcd8739ae039 = (0, $34Vv8.default)((0, $gWx6P.default));

});
parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

parcelRegister("gWx6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afe2164ad9e971d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $l0iMF = parcelRequire("l0iMF");

var $ibX2E = parcelRequire("ibX2E");

var $1Viru = parcelRequire("1Viru");
// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
class $0afe2164ad9e971d$var$ManagePagesLinkModal extends (0, $5uXOq.Component) {
    render() {
        const isOpen = this.props.isOpen ?? false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Viru.default), {
            Content: this.renderContent,
            onClose: this.props.onClose
        }));
    }
    constructor(...args){
        super(...args), this.onPagesLinkEnabledChange = ()=>{
            const { config: { isPagesLinkEnabled: isPagesLinkEnabled, setPagesLink: setPagesLink }, flagService: flagService } = this.props;
            setPagesLink(!isPagesLinkEnabled).catch(()=>{
                flagService.showFlag((0, $l0iMF.default)());
            });
        }, this.renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibX2E.default), {
                isEnabled: this.props.config.isPagesLinkEnabled,
                onEnabledChange: this.onPagesLinkEnabledChange
            });
    }
}
var $0afe2164ad9e971d$export$2e2bcd8739ae039 = $0afe2164ad9e971d$var$ManagePagesLinkModal;

});
parcelRegister("l0iMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $96817e8de39ea2a2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $96817e8de39ea2a2$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-shortcuts.flags.set-pages-link-error.title",
        "defaultMessage": "Something went wrong, but we're on it"
    },
    description: {
        "id": "navigation-shortcuts.flags.set-pages-link-error.description",
        "defaultMessage": "In the meantime, refresh this page. Contact support if you keep getting this message."
    }
});
const $96817e8de39ea2a2$var$setPagesLinkErrorFlag = ()=>({
        type: 'error',
        title: $96817e8de39ea2a2$var$messages.title,
        description: $96817e8de39ea2a2$var$messages.description,
        isAutoDismiss: true,
        messageId: 'navigation-shortcuts.flags.set-pages-link-error',
        messageType: 'transactional'
    });
var $96817e8de39ea2a2$export$2e2bcd8739ae039 = $96817e8de39ea2a2$var$setPagesLinkErrorFlag;

});

parcelRegister("ibX2E", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf604273be26e8ac$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $6XPNq = parcelRequire("6XPNq");
var $cf604273be26e8ac$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onEnabledChange: 'pages'
}), (0, $az4zD.injectIntlV2))((0, $6XPNq.default));

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("6XPNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b0232acbe81283a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");

var $fHMtf = parcelRequire("fHMtf");

var $2uVZm = parcelRequire("2uVZm");
const $1b0232acbe81283a$var$toggleId = 'navigation-shortcuts.manage-pages-link-modal.modal.toggle';
function $1b0232acbe81283a$var$Content(props) {
    const { intl: { formatMessage: formatMessage }, isEnabled: isEnabled, onEnabledChange: onEnabledChange } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        as: "label",
        htmlFor: $1b0232acbe81283a$var$toggleId
    }, formatMessage((0, $2uVZm.default).enablePagesLinkText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHMtf.default), {
        id: $1b0232acbe81283a$var$toggleId,
        isChecked: isEnabled,
        onChange: onEnabledChange
    })));
}
var $1b0232acbe81283a$export$2e2bcd8739ae039 = $1b0232acbe81283a$var$Content;

});
parcelRegister("fHMtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8dd5ff816ae367$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $aWYDr = parcelRequire("aWYDr");

var $9ojbB = parcelRequire("9ojbB");

var $fHpHg = parcelRequire("fHpHg");

var $8nOMf = parcelRequire("8nOMf");
const $1d8dd5ff816ae367$var$basicStyles = null;
const $1d8dd5ff816ae367$var$borderStyles = null;
const $1d8dd5ff816ae367$var$iconStyles = null;
const $1d8dd5ff816ae367$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $1d8dd5ff816ae367$var$noop = (0, $bKnKN.default);
const $1d8dd5ff816ae367$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1d8dd5ff816ae367$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $1d8dd5ff816ae367$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $1d8dd5ff816ae367$var$noop, onChange: providedChange = $1d8dd5ff816ae367$var$noop, onFocus: providedFocus = $1d8dd5ff816ae367$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const handleFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const handleChange = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$1d8dd5ff816ae367$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $1d8dd5ff816ae367$var$iconSizeMap[size];
    const labelId = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $fHpHg.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $1d8dd5ff816ae367$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8nOMf.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aWYDr))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8nOMf.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ojbB))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$1d8dd5ff816ae367$var$Toggle.displayName = 'Toggle';
var $1d8dd5ff816ae367$export$2e2bcd8739ae039 = $1d8dd5ff816ae367$var$Toggle;

});
parcelRegister("aWYDr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f8e5b0cf2a75074$var$_react = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f8e5b0cf2a75074$var$_checkMark = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $7f8e5b0cf2a75074$var$_done = $7f8e5b0cf2a75074$var$_interopRequireDefault((parcelRequire("4UpSr")));
function $7f8e5b0cf2a75074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f8e5b0cf2a75074$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7f8e5b0cf2a75074$var$_react.default.createElement($7f8e5b0cf2a75074$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $7f8e5b0cf2a75074$var$_done.default
    }, props));
$7f8e5b0cf2a75074$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $7f8e5b0cf2a75074$var$_default = module.exports.default = $7f8e5b0cf2a75074$var$CheckMarkIcon;

});
parcelRegister("aiSXl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780636fcbb2cccd4$var$_react = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780636fcbb2cccd4$var$_baseNew = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $780636fcbb2cccd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780636fcbb2cccd4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $780636fcbb2cccd4$var$_react.default.createElement($780636fcbb2cccd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$780636fcbb2cccd4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $780636fcbb2cccd4$var$_default = module.exports.default = $780636fcbb2cccd4$var$CheckMarkIcon;

});

parcelRegister("4UpSr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3930770d7c775047$var$_react = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3930770d7c775047$var$_checkMark = $3930770d7c775047$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $3930770d7c775047$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3930770d7c775047$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $3930770d7c775047$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $3930770d7c775047$var$_checkMark.default
    }));
$3930770d7c775047$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $3930770d7c775047$var$_default = module.exports.default = $3930770d7c775047$var$EditorDoneIcon;

});
parcelRegister("dVU8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a24c24cfbaad63c1$var$_react = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a24c24cfbaad63c1$var$_baseNew = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a24c24cfbaad63c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a24c24cfbaad63c1$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a24c24cfbaad63c1$var$_react.default.createElement($a24c24cfbaad63c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$a24c24cfbaad63c1$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a24c24cfbaad63c1$var$_default = module.exports.default = $a24c24cfbaad63c1$var$CheckMarkIcon;

});



parcelRegister("9ojbB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c13696afcc546e8bf0fe91a6c236c8d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d653cee5ee628ba$var$_react = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6d653cee5ee628ba$var$_cross = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gANiX")));

var $6d653cee5ee628ba$var$_close = $6d653cee5ee628ba$var$_interopRequireDefault((parcelRequire("gKTT6")));
function $6d653cee5ee628ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d653cee5ee628ba$var$CrossIcon = (props)=>/*#__PURE__*/ $6d653cee5ee628ba$var$_react.default.createElement($6d653cee5ee628ba$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $6d653cee5ee628ba$var$_close.default
    }, props));
$6d653cee5ee628ba$var$CrossIcon.Name = 'CrossIconMigration';
var $6d653cee5ee628ba$var$_default = module.exports.default = $6d653cee5ee628ba$var$CrossIcon;

});
parcelRegister("gKTT6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c32c4b58a13c4296$var$_react = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c32c4b58a13c4296$var$_close = $c32c4b58a13c4296$var$_interopRequireDefault((parcelRequire("eh9vz")));
function $c32c4b58a13c4296$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c32c4b58a13c4296$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $c32c4b58a13c4296$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $c32c4b58a13c4296$var$_close.default
    }));
$c32c4b58a13c4296$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $c32c4b58a13c4296$var$_default = module.exports.default = $c32c4b58a13c4296$var$EditorCloseIcon;

});


parcelRegister("8nOMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $300b858f6a112f45$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
const $300b858f6a112f45$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $300b858f6a112f45$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "span",
        xcss: (0, $6tzHJ.cx)($300b858f6a112f45$var$styles.iconContainer, isHidden && (0, $fHpHg.fg)('platform-visual-refresh-icons') && $300b858f6a112f45$var$styles.hidden, size === 'regular' && $300b858f6a112f45$var$styles.iconContainerRegular, size === 'large' && $300b858f6a112f45$var$styles.iconContainerLarge, position === 'left' && $300b858f6a112f45$var$styles.left, position === 'right' && $300b858f6a112f45$var$styles.right),
        children: children
    });
};
var $300b858f6a112f45$export$2e2bcd8739ae039 = $300b858f6a112f45$var$IconContainer;

});


parcelRegister("2uVZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc8e4afe9500c07$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1dc8e4afe9500c07$var$messages = (0, $7VHMR.defineMessages)({
    enablePagesLinkText: {
        "id": "navigation-shortcuts.common.messages.pages-messages.enable-pages-link-text",
        "defaultMessage": "Create, share and collaborate on all your project docs in one place with Confluence pages."
    }
});
var $1dc8e4afe9500c07$export$2e2bcd8739ae039 = $1dc8e4afe9500c07$var$messages;

});



parcelRegister("1Viru", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f6d5c651897733$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");


var $mdQzV = parcelRequire("mdQzV");
var $b3f6d5c651897733$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSource)('managePagesLink', (0, $4d5e0871c06cee03$export$1171103ea9083ffa)), (0, $iQv12.default)({
    onClose: 'close'
}), (0, $az4zD.injectIntlV2))((0, $mdQzV.default));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("mdQzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c245dfaa723f40$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $7NYq5 = parcelRequire("7NYq5");

var $a5zfA = parcelRequire("a5zfA");

var $fUCAp = parcelRequire("fUCAp");
function $f4c245dfaa723f40$var$Modal(props) {
    const { Content: Content, onClose: onClose, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        label: formatMessage((0, $fUCAp.default).heading),
        onClose: onClose,
        autoFocus: false,
        shouldCloseOnOverlayClick: false,
        messageId: "navigation-shortcuts.manage-pages-link-modal.modal.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5zfA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4c245dfaa723f40$var$ContentWrapper, null, (0, $4R6GH.fg)('blu-6207-a11y-empty-states-headings-images') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $f4c245dfaa723f40$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "large",
        as: "h1"
    }, formatMessage((0, $fUCAp.default).heading))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4c245dfaa723f40$var$HeadingOld, null, formatMessage((0, $fUCAp.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "link",
        onClick: onClose
    }, formatMessage((0, $fUCAp.default).close)))));
}
var $f4c245dfaa723f40$export$2e2bcd8739ae039 = $f4c245dfaa723f40$var$Modal;
const $f4c245dfaa723f40$var$headingWrapperStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c245dfaa723f40$var$HeadingOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c245dfaa723f40$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3pxbi _n3tdidpf _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $asiGE.default)({
    componentName: 'view-tracker'
})((0, $3TR0I.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("a5zfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c49890ed47f25ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fMTnd = parcelRequire("fMTnd");

var $blhnb = parcelRequire("blhnb");
const $5c49890ed47f25ec$var$Header = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blhnb.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fMTnd)))
    });
var $5c49890ed47f25ec$export$2e2bcd8739ae039 = $5c49890ed47f25ec$var$Header;

});
parcelRegister("fMTnd", function(module, exports) {
module.exports = new URL("confluence-pages.bd4cb8cc.svg", import.meta.url).toString();

});

parcelRegister("blhnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf50477ba4cb29dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cf50477ba4cb29dd$var$ImageHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$BackgroundContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf50477ba4cb29dd$var$ImageContainer, {
        src: props.src,
        alt: ""
    })));
var $cf50477ba4cb29dd$export$2e2bcd8739ae039 = $cf50477ba4cb29dd$var$ImageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf50477ba4cb29dd$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb17n1 _4t3i7iqz",
            __cmplp.className
        ])
    });
});
const $cf50477ba4cb29dd$var$HeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $cf50477ba4cb29dd$var$BackgroundContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _4t3i1wqb _bfhkfg4m _1eaz1osq _1f00gktf _1g0kx099",
            __cmplp.className
        ])
    });
});
const $cf50477ba4cb29dd$var$ImageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fUCAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea00525a84246a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1ea00525a84246a5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "navigation-shortcuts.manage-pages-link-modal.modal.heading",
        "defaultMessage": "Manage project pages"
    },
    close: {
        "id": "navigation-shortcuts.manage-pages-link-modal.modal.close",
        "defaultMessage": "Close"
    }
});

});







//# sourceMappingURL=async-navigation-shortcuts.5aeead35.js.map
